import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets/images/arrow_left_black.svg'


const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = { class: "v-card-header d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "svg align-text-bottom text-black me-1",
  height: "18",
  width: "18",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "flex-fill" }
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = {
  href: "javascript:;",
  class: "dropdown-toggle no-dropdown-symb small-link",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_9 = {
  key: 0,
  class: "dropdown-item py-2"
}
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "flex-fill" }
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["title", "onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash3-fill" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-square-fill" }, null, -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 2,
  class: "dropdown"
}
const _hoisted_23 = {
  href: "javascript:;",
  class: "dropdown-toggle no-dropdown-symb small-link",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_26 = {
  key: 0,
  class: "dropdown-item py-2"
}
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = { class: "flex-fill" }
const _hoisted_29 = ["title", "onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["title", "onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash3-fill" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-square-fill" }, null, -1)
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "v-card-body" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { for: "SKU" }
const _hoisted_43 = ["placeholder", "disabled"]
const _hoisted_44 = { class: "info-msg text-muted small" }
const _hoisted_45 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_46 = { for: "Name" }
const _hoisted_47 = ["placeholder", "disabled"]
const _hoisted_48 = { class: "info-msg text-muted small" }
const _hoisted_49 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_50 = { for: "BarCode" }
const _hoisted_51 = ["placeholder", "disabled"]
const _hoisted_52 = { class: "info-msg text-muted small" }
const _hoisted_53 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_54 = { for: "ProductType" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { value: 0 }
const _hoisted_57 = { value: 1 }
const _hoisted_58 = { class: "info-msg text-muted small" }
const _hoisted_59 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_60 = { for: "Categories" }
const _hoisted_61 = { class: "dropdown" }
const _hoisted_62 = {
  href: "javascript:;",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  class: "dropdown-toggle no-dropdown-symb"
}
const _hoisted_63 = { class: "dropdown-menu" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { class: "categories d-flex flex-wrap p" }
const _hoisted_66 = {
  key: 0,
  class: "no-categ text-warning text-bold"
}
const _hoisted_67 = { class: "categ-list-elt d-flex flex-wrap" }
const _hoisted_68 = { class: "flex-fill me-2" }
const _hoisted_69 = ["title", "onClick"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-square-fill" }, null, -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_73 = { for: "SubCategories" }
const _hoisted_74 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_75 = {
  href: "javascript:;",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  class: "dropdown-toggle no-dropdown-symb"
}
const _hoisted_76 = { class: "dropdown-menu" }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = { class: "categories d-flex flex-wrap p" }
const _hoisted_79 = {
  key: 0,
  class: "no-categ text-warning text-bold"
}
const _hoisted_80 = { class: "categ-list-elt d-flex flex-wrap" }
const _hoisted_81 = { class: "flex-fill me-2" }
const _hoisted_82 = ["title", "onClick"]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-square-fill" }, null, -1)
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_86 = { for: "BrandCode" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = { value: "" }
const _hoisted_89 = ["value"]
const _hoisted_90 = { class: "info-msg text-muted small" }
const _hoisted_91 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_92 = { class: "col-md-6 d-flex flex-column justify-content-end py-md-3" }
const _hoisted_93 = { class: "form-check" }
const _hoisted_94 = {
  class: "form-check-label",
  for: "IsKeepStock"
}
const _hoisted_95 = { class: "info-msg text-muted small" }
const _hoisted_96 = { class: "col-md-6 d-flex flex-column justify-content-end py-md-3" }
const _hoisted_97 = { class: "form-check" }
const _hoisted_98 = {
  class: "form-check-label",
  for: "IsTaxable"
}
const _hoisted_99 = { class: "info-msg text-muted small" }
const _hoisted_100 = { class: "col-md-6 d-flex flex-column justify-content-end py-md-3" }
const _hoisted_101 = { class: "form-check" }
const _hoisted_102 = {
  class: "form-check-label",
  for: "AllowPurchaseOutStock"
}
const _hoisted_103 = { class: "info-msg text-muted small" }
const _hoisted_104 = { for: "ReorderQuantity" }
const _hoisted_105 = ["placeholder", "disabled"]
const _hoisted_106 = { class: "info-msg text-muted small" }
const _hoisted_107 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_108 = { for: "MinOrderQuantity" }
const _hoisted_109 = ["placeholder", "disabled"]
const _hoisted_110 = { class: "info-msg text-muted small" }
const _hoisted_111 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_112 = { for: "PurchasePrice" }
const _hoisted_113 = ["placeholder", "disabled"]
const _hoisted_114 = { class: "info-msg text-muted small" }
const _hoisted_115 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_116 = { for: "SellingPrice" }
const _hoisted_117 = ["placeholder", "disabled"]
const _hoisted_118 = { class: "info-msg text-muted small" }
const _hoisted_119 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_120 = { class: "col-md-6 form-group" }
const _hoisted_121 = { for: "DefaultSupplier" }
const _hoisted_122 = ["disabled"]
const _hoisted_123 = { value: "" }
const _hoisted_124 = ["value"]
const _hoisted_125 = { class: "info-msg py-2 text-muted small" }
const _hoisted_126 = { class: "col-md-6 form-group" }
const _hoisted_127 = { for: "DefaultTax" }
const _hoisted_128 = ["disabled"]
const _hoisted_129 = { value: "" }
const _hoisted_130 = ["value"]
const _hoisted_131 = { class: "info-msg py-2 text-muted small" }
const _hoisted_132 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_133 = { class: "col-md" }
const _hoisted_134 = { class: "row" }
const _hoisted_135 = { for: "UnitOfMeasuremt" }
const _hoisted_136 = ["placeholder", "disabled"]
const _hoisted_137 = { class: "info-msg text-muted small" }
const _hoisted_138 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_139 = { for: "PcePerUnit" }
const _hoisted_140 = ["placeholder", "disabled"]
const _hoisted_141 = { class: "info-msg text-muted small" }
const _hoisted_142 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_143 = { class: "col-md-6 form-group" }
const _hoisted_144 = { for: "Tags" }
const _hoisted_145 = { class: "info-msg py-2 text-muted small" }
const _hoisted_146 = { class: "col-md-12 form-group" }
const _hoisted_147 = { for: "Description" }
const _hoisted_148 = ["placeholder", "disabled"]
const _hoisted_149 = { class: "info-msg text-muted small" }
const _hoisted_150 = { class: "form-group image-space-zone" }
const _hoisted_151 = { class: "mb-3" }
const _hoisted_152 = { class: "all-images" }
const _hoisted_153 = { class: "defualt-img-area" }
const _hoisted_154 = { class: "image-wrapper" }
const _hoisted_155 = { class: "mb-3" }
const _hoisted_156 = {
  class: "prod-image",
  id: "prodImage0"
}
const _hoisted_157 = { class: "prod-image-commands" }
const _hoisted_158 = { class: "inner-controls" }
const _hoisted_159 = ["src"]
const _hoisted_160 = {
  key: 0,
  class: "prod-image-remove-area"
}
const _hoisted_161 = ["title"]
const _hoisted_162 = {
  key: 1,
  class: "prod-image-save-area"
}
const _hoisted_163 = ["title"]
const _hoisted_164 = ["title"]
const _hoisted_165 = { class: "defualt-img-area mt-4" }
const _hoisted_166 = { class: "mb-3" }
const _hoisted_167 = { class: "d-flex flex-wrap justify-content-around" }
const _hoisted_168 = { class: "image-wrapper mr-2" }
const _hoisted_169 = {
  class: "prod-image",
  id: "prodImage1"
}
const _hoisted_170 = { class: "prod-image-commands" }
const _hoisted_171 = { class: "inner-controls" }
const _hoisted_172 = ["src"]
const _hoisted_173 = {
  key: 0,
  class: "prod-image-remove-area"
}
const _hoisted_174 = ["title"]
const _hoisted_175 = {
  key: 1,
  class: "prod-image-save-area"
}
const _hoisted_176 = ["title"]
const _hoisted_177 = ["title"]
const _hoisted_178 = { class: "image-wrapper mr-2" }
const _hoisted_179 = {
  class: "prod-image",
  id: "prodImage2"
}
const _hoisted_180 = { class: "prod-image-commands" }
const _hoisted_181 = { class: "inner-controls" }
const _hoisted_182 = ["src"]
const _hoisted_183 = {
  key: 0,
  class: "prod-image-remove-area"
}
const _hoisted_184 = ["title"]
const _hoisted_185 = {
  key: 1,
  class: "prod-image-save-area"
}
const _hoisted_186 = ["title"]
const _hoisted_187 = ["title"]
const _hoisted_188 = { class: "image-wrapper mr-2" }
const _hoisted_189 = {
  class: "prod-image",
  id: "prodImage1"
}
const _hoisted_190 = { class: "prod-image-commands" }
const _hoisted_191 = { class: "inner-controls" }
const _hoisted_192 = ["src"]
const _hoisted_193 = {
  key: 0,
  class: "prod-image-remove-area"
}
const _hoisted_194 = ["title"]
const _hoisted_195 = {
  key: 1,
  class: "prod-image-save-area"
}
const _hoisted_196 = ["title"]
const _hoisted_197 = ["title"]
const _hoisted_198 = { class: "image-wrapper mr-2" }
const _hoisted_199 = {
  class: "prod-image",
  id: "prodImage4"
}
const _hoisted_200 = { class: "prod-image-commands" }
const _hoisted_201 = { class: "inner-controls" }
const _hoisted_202 = ["src"]
const _hoisted_203 = {
  key: 0,
  class: "prod-image-remove-area"
}
const _hoisted_204 = ["title"]
const _hoisted_205 = {
  key: 1,
  class: "prod-image-save-area"
}
const _hoisted_206 = ["title"]
const _hoisted_207 = ["title"]
const _hoisted_208 = { class: "image-wrapper mr-2" }
const _hoisted_209 = {
  class: "prod-image",
  id: "prodImage5"
}
const _hoisted_210 = { class: "prod-image-commands" }
const _hoisted_211 = { class: "inner-controls" }
const _hoisted_212 = ["src"]
const _hoisted_213 = {
  key: 0,
  class: "prod-image-remove-area"
}
const _hoisted_214 = ["title"]
const _hoisted_215 = {
  key: 1,
  class: "prod-image-save-area"
}
const _hoisted_216 = ["title"]
const _hoisted_217 = ["title"]
const _hoisted_218 = { class: "mx-3 my-4" }
const _hoisted_219 = { class: "mt-4" }
const _hoisted_220 = ["disabled"]
const _hoisted_221 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_barcode = _resolveComponent("barcode")!
  const _component_jw_tag_input_v2 = _resolveComponent("jw-tag-input-v2")!
  const _component_ProdCategoryModal = _resolveComponent("ProdCategoryModal")!
  const _component_ProdSubCategoryModal = _resolveComponent("ProdSubCategoryModal")!
  const _component_ProdVariantModal = _resolveComponent("ProdVariantModal")!
  const _component_ProdVariantValueModal = _resolveComponent("ProdVariantValueModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["v-card", {'d-none': _ctx.isStillLoading}])
    }, [
      _createElementVNode("h1", _hoisted_2, [
        _createVNode(_component_RouterLink, { to: "/app/products/products/list" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.isStillLoading ? `${_ctx.language.loading}...`: _ctx.foundProduct.Name), 1),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.language.variants) + "  ", 1),
              (_ctx.lstProdVariants.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(" + _toDisplayString(_ctx.lstProdVariants.length) + ")", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.lstProdVariants.length == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.language.no_variant_fnd), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstProdVariants, (oVar) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "dropdown-item py-2",
                  key: oVar.IdVariant
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(oVar.VariantCode), 1),
                    _createTextVNode("  "),
                    _createElementVNode("a", {
                      href: "javascript:;",
                      title: _ctx.language.preview,
                      onClick: ($event: any) => (_ctx.addEditVariantCode(1, oVar))
                    }, _hoisted_14, 8, _hoisted_12),
                    _createTextVNode("  "),
                    _createElementVNode("a", {
                      href: "javascript:;",
                      class: "text-danger",
                      title: _ctx.language.delete,
                      onClick: ($event: any) => (_ctx.deleteVariantCode(oVar))
                    }, _hoisted_17, 8, _hoisted_15),
                    _createTextVNode("  ")
                  ])
                ]))
              }), 128)),
              _hoisted_18,
              _createElementVNode("a", {
                class: "dropdown-item py-2",
                href: "javascript:;",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addEditVariantCode(0, null)))
              }, [
                _hoisted_19,
                _createTextVNode(" " + _toDisplayString(_ctx.language.add_variant), 1)
              ])
            ])
          ]),
          (_ctx.lstProdVariants.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, " "))
            : _createCommentVNode("", true),
          (_ctx.lstProdVariants.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, " | "))
            : _createCommentVNode("", true),
          (_ctx.lstProdVariants.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                _createElementVNode("a", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_ctx.language.variant_detail) + "  ", 1),
                  (_ctx.lstProdVariantValues.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "(" + _toDisplayString(_ctx.lstProdVariantValues.length) + ")", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.lstProdVariantValues.length == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.language.no_variant_det_fnd), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstProdVariantValues, (oVar) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "dropdown-item py-2",
                      key: oVar.IdVariantDetail
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(oVar.VariantValues), 1),
                        _createTextVNode("  "),
                        _createElementVNode("a", {
                          href: "javascript:;",
                          title: _ctx.language.preview,
                          onClick: ($event: any) => (_ctx.addEditVariantVal(1, oVar))
                        }, _hoisted_31, 8, _hoisted_29),
                        _createTextVNode("  "),
                        _createElementVNode("a", {
                          href: "javascript:;",
                          class: "text-danger",
                          title: _ctx.language.delete,
                          onClick: ($event: any) => (_ctx.deleteVariantDetail(oVar))
                        }, _hoisted_34, 8, _hoisted_32),
                        _createTextVNode("  ")
                      ])
                    ]))
                  }), 128)),
                  _hoisted_35,
                  _createElementVNode("a", {
                    class: "dropdown-item py-2",
                    href: "javascript:;",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addEditVariantVal(0, null)))
                  }, [
                    _hoisted_36,
                    _createTextVNode(" " + _toDisplayString(_ctx.language.add_variant_det), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createTextVNode("  "),
          _createElementVNode("button", {
            type: "button",
            class: "btn-xs xs-primary",
            disabled: _ctx.v$.$invalid || _ctx.isSavingRecord || !_ctx.isDefaultTaxReqSet,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveNewProduct && _ctx.saveNewProduct(...args)))
          }, [
            (_ctx.isSavingRecord)
              ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-spinner'] }),
                  _createTextVNode("  ")
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_39, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] }),
                  _createTextVNode("  ")
                ])),
            _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
          ], 8, _hoisted_37)
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.SKU.$error}])
          }, [
            _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.language.sku), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "SKU",
              class: "form-control tab-press telephone-nbr",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataRecord.SKU) = $event)),
              placeholder: '(' + _ctx.language.sku_ex.toLowerCase() + ')',
              maxlength: "12",
              autocomplete: "off",
              onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord || _ctx.dataRecord.ProdProductId != 0
            }, null, 40, _hoisted_43), [
              [_vModelText, _ctx.dataRecord.SKU]
            ]),
            _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.language.sku_info_msg), 1),
            (_ctx.v$.dataRecord.SKU.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.v$.dataRecord.SKU.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.Name.$error}])
          }, [
            _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.language.name), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "Name",
              class: "form-control tab-press",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dataRecord.Name) = $event)),
              placeholder: '(' + _ctx.language.name.toLowerCase() + ')',
              maxlength: "50",
              autocomplete: "off",
              onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord
            }, null, 40, _hoisted_47), [
              [_vModelText, _ctx.dataRecord.Name]
            ]),
            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.language.name_prod_info_msg), 1),
            (_ctx.v$.dataRecord.Name.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.v$.dataRecord.Name.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.BarCode.$error}])
          }, [
            _createElementVNode("label", _hoisted_50, [
              _createTextVNode(_toDisplayString(_ctx.language.barcode) + "  ", 1),
              _createElementVNode("a", {
                href: "javascript:;",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.generateBarCode(null)))
              }, "(" + _toDisplayString(_ctx.language.generate_barcode.toLowerCase()) + ")", 1)
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "BarCode",
              class: "form-control tab-press",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dataRecord.BarCode) = $event)),
              placeholder: '(' + _ctx.language.barcode_ex.toLowerCase() + ')',
              maxlength: "10",
              autocomplete: "off",
              onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord || _ctx.dataRecord.ProdProductId != 0,
              onKeyup: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onKeyUpRawBarcode && _ctx.onKeyUpRawBarcode(...args)))
            }, null, 40, _hoisted_51), [
              [_vModelText, _ctx.dataRecord.BarCode]
            ]),
            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.language.barcode_info_msg), 1),
            (_ctx.v$.dataRecord.BarCode.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.v$.dataRecord.BarCode.$errors[0].$message), 1))
              : _createCommentVNode("", true),
            (_ctx.isBarCodeReady && _ctx.dataRecord.BarCode.length == 10)
              ? (_openBlock(), _createBlock(_component_barcode, {
                  key: 1,
                  value: _ctx.dataRecord.BarCode
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Show this if the rendering fails. ")
                  ]),
                  _: 1
                }, 8, ["value"]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.ProductType.$error}])
          }, [
            _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.language.type), 1),
            _withDirectives(_createElementVNode("select", {
              id: "ProductType",
              class: "form-control-sel tab-press",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dataRecord.ProductType) = $event)),
              disabled: _ctx.isSavingRecord || _ctx.dataRecord.ProdProductId != 0
            }, [
              _createElementVNode("option", _hoisted_56, _toDisplayString(_ctx.language.product), 1),
              _createElementVNode("option", _hoisted_57, _toDisplayString(_ctx.language.service), 1)
            ], 8, _hoisted_55), [
              [_vModelSelect, _ctx.dataRecord.ProductType]
            ]),
            _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.language.product_type_info_msg), 1),
            (_ctx.v$.dataRecord.ProductType.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.v$.dataRecord.ProductType.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.Categories.$error}])
          }, [
            _createElementVNode("label", _hoisted_60, [
              _createTextVNode(_toDisplayString(_ctx.language.categories) + "  (", 1),
              _createElementVNode("span", _hoisted_61, [
                _createElementVNode("a", _hoisted_62, _toDisplayString(_ctx.language.select_category.toLowerCase()), 1),
                _createElementVNode("ul", _hoisted_63, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstCategories, (oCateg) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: oCateg.Code
                    }, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:;",
                        onClick: ($event: any) => (_ctx.selectCategory(oCateg))
                      }, _toDisplayString(_ctx.getCategoryName(oCateg)), 9, _hoisted_64)
                    ]))
                  }), 128))
                ])
              ]),
              _createTextVNode(") ("),
              _createElementVNode("a", {
                href: "javascript:;",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.addCategoryElement && _ctx.addCategoryElement(...args)))
              }, _toDisplayString(_ctx.language.new_categ.toLowerCase()), 1),
              _createTextVNode(") ")
            ]),
            _createElementVNode("div", _hoisted_65, [
              (_ctx.selectedCategories.length == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.language.no_categ_selected), 1))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_67, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCategories, (oSelC) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: oSelC.Code,
                    class: "d-flex my-1 me-1 p-2"
                  }, [
                    _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.getCategoryName(oSelC)), 1),
                    _createElementVNode("span", null, [
                      _createElementVNode("a", {
                        href: "javascript:;",
                        class: "text-danger",
                        title: _ctx.language.remove_category,
                        onClick: ($event: any) => (_ctx.removeSelectedCategory(oSelC))
                      }, _hoisted_71, 8, _hoisted_69)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.v$.dataRecord.Categories.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.v$.dataRecord.Categories.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.SubCategories.$error}])
          }, [
            _createElementVNode("label", _hoisted_73, [
              _createTextVNode(_toDisplayString(_ctx.language.sub_categories) + "  ", 1),
              (_ctx.possibleSubCategories.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_74, [
                    _createElementVNode("a", _hoisted_75, "(" + _toDisplayString(_ctx.language.add_sub_categ.toLowerCase()) + ")", 1),
                    _createElementVNode("ul", _hoisted_76, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.possibleSubCategories, (oSubCateg) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: oSubCateg.Code + '' + oSubCateg.SubCode
                        }, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.selectSubCategory(oSubCateg))
                          }, _toDisplayString(_ctx.getSubCategoryName(oSubCateg)), 9, _hoisted_77)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(" ("),
              _createElementVNode("a", {
                href: "javascript:;",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addSubCategoryElement && _ctx.addSubCategoryElement(...args)))
              }, _toDisplayString(_ctx.language.new_sub_categ.toLowerCase()), 1),
              _createTextVNode(") ")
            ]),
            _createElementVNode("div", _hoisted_78, [
              (_ctx.selectedSubCategories.length == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(_ctx.language.no_sub_categ_selected), 1))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_80, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSubCategories, (oSelC) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: oSelC.Code + '' + oSelC.SubCode,
                    class: "d-flex my-1 me-1 p-2"
                  }, [
                    _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.getSubCategoryName(oSelC)), 1),
                    _createElementVNode("span", null, [
                      _createElementVNode("a", {
                        href: "javascript:;",
                        class: "text-danger",
                        title: _ctx.language.remove_category,
                        onClick: ($event: any) => (_ctx.removeSelectedSubCategory(oSelC))
                      }, _hoisted_84, 8, _hoisted_82)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.v$.dataRecord.SubCategories.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_ctx.v$.dataRecord.SubCategories.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.BrandCode.$error}])
          }, [
            _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.language.brand), 1),
            _withDirectives(_createElementVNode("select", {
              id: "BrandCode",
              class: "form-control-sel tab-press",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dataRecord.BrandCode) = $event)),
              disabled: _ctx.isSavingRecord
            }, [
              _createElementVNode("option", _hoisted_88, _toDisplayString(_ctx.language.select_brand), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstBrands, (oBrand) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: oBrand.Code,
                  key: oBrand.Code
                }, _toDisplayString(oBrand.BrandName), 9, _hoisted_89))
              }), 128))
            ], 8, _hoisted_87), [
              [_vModelSelect, _ctx.dataRecord.BrandCode]
            ]),
            _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.language.brand_info_msg), 1),
            (_ctx.v$.dataRecord.BrandCode.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(_ctx.v$.dataRecord.BrandCode.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dataRecord.IsKeepStock) = $event)),
                id: "IsKeepStock"
              }, null, 512), [
                [_vModelCheckbox, _ctx.dataRecord.IsKeepStock]
              ]),
              _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.language.track_stock), 1)
            ]),
            _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.language.track_stock_info_msg), 1)
          ]),
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dataRecord.IsTaxable) = $event)),
                id: "IsTaxable",
                onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onTaxChanged && _ctx.onTaxChanged(...args)))
              }, null, 544), [
                [_vModelCheckbox, _ctx.dataRecord.IsTaxable]
              ]),
              _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.language.is_taxable), 1)
            ]),
            _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.language.is_taxable_info_msg), 1)
          ]),
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("div", _hoisted_101, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dataRecord.AllowPurchaseOutStock) = $event)),
                id: "AllowPurchaseOutStock"
              }, null, 512), [
                [_vModelCheckbox, _ctx.dataRecord.AllowPurchaseOutStock]
              ]),
              _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.language.allow_sales_out_stock), 1)
            ]),
            _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.language.allow_sales_out_stock_info_msg), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.ReorderQuantity.$error}])
          }, [
            _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.language.reorder_quantity), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "ReorderQuantity",
              class: "form-control numeric tab-press text-end",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.dataRecord.ReorderQuantity) = $event)),
              placeholder: '(' + _ctx.language.reorder_quantity.toLowerCase() + ')',
              maxlength: "5",
              autocomplete: "off",
              onFocus: _cache[20] || (_cache[20] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord
            }, null, 40, _hoisted_105), [
              [_vModelText, _ctx.dataRecord.ReorderQuantity]
            ]),
            _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.language.reorder_quantity_info_msg), 1),
            (_ctx.v$.dataRecord.ReorderQuantity.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_107, _toDisplayString(_ctx.v$.dataRecord.ReorderQuantity.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.MinOrderQuantity.$error}])
          }, [
            _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.language.minimum_order_qty), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "MinOrderQuantity",
              class: "form-control numeric tab-press text-end",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.dataRecord.MinOrderQuantity) = $event)),
              placeholder: '(' + _ctx.language.minimum_order_qty.toLowerCase() + ')',
              maxlength: "5",
              autocomplete: "off",
              onFocus: _cache[22] || (_cache[22] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord
            }, null, 40, _hoisted_109), [
              [_vModelText, _ctx.dataRecord.MinOrderQuantity]
            ]),
            _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.language.minimum_order_qty_info_msg), 1),
            (_ctx.v$.dataRecord.MinOrderQuantity.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_111, _toDisplayString(_ctx.v$.dataRecord.MinOrderQuantity.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.PurchasePrice.$error}])
          }, [
            _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.language.purchase_price), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "PurchasePrice",
              class: "form-control numeric tab-press text-end",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.dataRecord.PurchasePrice) = $event)),
              placeholder: '(' + _ctx.language.purchase_price.toLowerCase() + ')',
              maxlength: "20",
              autocomplete: "off",
              onFocus: _cache[24] || (_cache[24] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord
            }, null, 40, _hoisted_113), [
              [_vModelText, _ctx.dataRecord.PurchasePrice]
            ]),
            _createElementVNode("div", _hoisted_114, _toDisplayString(_ctx.language.purchase_price_info_msg), 1),
            (_ctx.v$.dataRecord.PurchasePrice.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_115, _toDisplayString(_ctx.v$.dataRecord.PurchasePrice.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.SellingPrice.$error}])
          }, [
            _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.language.selling_price), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "SellingPrice",
              class: "form-control numeric tab-press text-end",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.dataRecord.SellingPrice) = $event)),
              placeholder: '(' + _ctx.language.selling_price.toLowerCase() + ')',
              maxlength: "20",
              autocomplete: "off",
              onFocus: _cache[26] || (_cache[26] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord
            }, null, 40, _hoisted_117), [
              [_vModelText, _ctx.dataRecord.SellingPrice]
            ]),
            _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.language.selling_price_info_msg), 1),
            (_ctx.v$.dataRecord.SellingPrice.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_119, _toDisplayString(_ctx.v$.dataRecord.SellingPrice.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.language.default_supplier), 1),
            _withDirectives(_createElementVNode("select", {
              id: "DefaultSupplier",
              class: "form-control-sel tab-press",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.dataRecord.DefaultSupplier) = $event)),
              disabled: _ctx.isSavingRecord
            }, [
              _createElementVNode("option", _hoisted_123, _toDisplayString(_ctx.language.select_supplier + ' (' + _ctx.language.none_selected.toLowerCase() + ')'), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstSuppliers, (oSupplier) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: oSupplier.SupplierKey,
                  key: oSupplier.IdSupplier
                }, _toDisplayString(oSupplier.SupplierName), 9, _hoisted_124))
              }), 128))
            ], 8, _hoisted_122), [
              [_vModelSelect, _ctx.dataRecord.DefaultSupplier]
            ]),
            _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.language.default_supplier_info_msg), 1)
          ]),
          _createElementVNode("div", _hoisted_126, [
            _createElementVNode("label", _hoisted_127, _toDisplayString(_ctx.language.default_tax), 1),
            _withDirectives(_createElementVNode("select", {
              id: "DefaultTax",
              class: "form-control-sel tab-press",
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.dataRecord.DefaultTax) = $event)),
              disabled: _ctx.isSavingRecord || !_ctx.dataRecord.IsTaxable
            }, [
              _createElementVNode("option", _hoisted_129, _toDisplayString(_ctx.language.select_tax + ' (' + _ctx.language.none_selected.toLowerCase() + ')'), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstTaxes, (oTax) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: oTax.TaxKey,
                  key: oTax.TaxKey
                }, _toDisplayString(oTax.TaxName), 9, _hoisted_130))
              }), 128))
            ], 8, _hoisted_128), [
              [_vModelSelect, _ctx.dataRecord.DefaultTax]
            ]),
            _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.language.default_tax_info_msg), 1),
            (!_ctx.isDefaultTaxReqSet)
              ? (_openBlock(), _createElementBlock("div", _hoisted_132, _toDisplayString(_ctx.language.default_tax_msg_error), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("div", {
                class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.UnitOfMeasuremt.$error}])
              }, [
                _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.language.uom_sh), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "UnitOfMeasuremt",
                  class: "form-control tab-press",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.dataRecord.UnitOfMeasuremt) = $event)),
                  placeholder: '(' + _ctx.language.uom_sh.toLowerCase() + ')',
                  maxlength: "50",
                  autocomplete: "off",
                  onFocus: _cache[30] || (_cache[30] = ($event: any) => (_ctx.selectOnFocus($event))),
                  disabled: _ctx.isSavingRecord || _ctx.dataRecord.ProdProductId != 0
                }, null, 40, _hoisted_136), [
                  [_vModelText, _ctx.dataRecord.UnitOfMeasuremt]
                ]),
                _createElementVNode("div", _hoisted_137, _toDisplayString(_ctx.language.uom_info_msg), 1),
                (_ctx.v$.dataRecord.UnitOfMeasuremt.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(_ctx.v$.dataRecord.UnitOfMeasuremt.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.PcePerUnit.$error}])
              }, [
                _createElementVNode("label", _hoisted_139, _toDisplayString(_ctx.language.pces_per_unit), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "PcePerUnit",
                  class: "form-control tab-press numeric",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.dataRecord.PcePerUnit) = $event)),
                  placeholder: '(' + _ctx.language.pces_per_unit.toLowerCase() + ')',
                  maxlength: "3",
                  autocomplete: "off",
                  onFocus: _cache[32] || (_cache[32] = ($event: any) => (_ctx.selectOnFocus($event))),
                  disabled: _ctx.isSavingRecord || _ctx.dataRecord.ProdProductId != 0
                }, null, 40, _hoisted_140), [
                  [_vModelText, _ctx.dataRecord.PcePerUnit]
                ]),
                _createElementVNode("div", _hoisted_141, _toDisplayString(_ctx.language.pces_per_unit_msg), 1),
                (_ctx.v$.dataRecord.PcePerUnit.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_142, _toDisplayString(_ctx.v$.dataRecord.PcePerUnit.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.language.tags), 1),
            _createVNode(_component_jw_tag_input_v2, {
              initialTags: _ctx.tags,
              onAfterUpdate: _ctx.updateTags,
              disabled: _ctx.isSavingRecord
            }, null, 8, ["initialTags", "onAfterUpdate", "disabled"]),
            _createElementVNode("div", _hoisted_145, _toDisplayString(_ctx.language.tags_info_details), 1)
          ]),
          _createElementVNode("div", _hoisted_146, [
            _createElementVNode("label", _hoisted_147, _toDisplayString(_ctx.language.description), 1),
            _withDirectives(_createElementVNode("textarea", {
              id: "Description",
              class: "form-control tab-press",
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.dataRecord.Description) = $event)),
              placeholder: '(' + _ctx.language.description.toLowerCase() + ')',
              maxlength: "500",
              autocomplete: "off",
              onFocus: _cache[34] || (_cache[34] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord,
              rows: "3"
            }, null, 40, _hoisted_148), [
              [_vModelText, _ctx.dataRecord.Description]
            ]),
            _createElementVNode("div", _hoisted_149, _toDisplayString(_ctx.language.description_prod_info_msg), 1)
          ]),
          _createElementVNode("div", _hoisted_150, [
            _createElementVNode("h3", _hoisted_151, _toDisplayString(_ctx.language.images), 1),
            _createElementVNode("input", {
              type: "file",
              id: "imageFileSelectors",
              accept: "image/*",
              onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.onSelectedImageToUpload && _ctx.onSelectedImageToUpload(...args))),
              style: {"display":"none"}
            }, null, 32),
            _createElementVNode("div", _hoisted_152, [
              _createElementVNode("div", _hoisted_153, [
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("h4", _hoisted_155, _toDisplayString(_ctx.language.default_image), 1),
                  _createElementVNode("div", _hoisted_156, [
                    _createElementVNode("div", _hoisted_157, [
                      _createElementVNode("div", _hoisted_158, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.language.add_image.toLowerCase()), 1),
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.uploadImage(0)))
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-plus'] })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["prod-image-zone", {'d-none':!_ctx.isDefImgReady}])
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.prodImgDefSrc,
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.previewProdImage(0)))
                      }, null, 8, _hoisted_159)
                    ], 2),
                    (_ctx.foundProduct.DefaultImage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                          _createElementVNode("a", {
                            href: "javascript:;",
                            title: _ctx.language.remove_this_img,
                            onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.removeImage(0)))
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: ['fa', 'fa-trash'],
                              class: "text-danger"
                            })
                          ], 8, _hoisted_161)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.allImages.defaultImage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                          _createElementVNode("a", {
                            href: "javascript:;",
                            title: _ctx.language.remove_this_img,
                            onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.resetImage(0)))
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: ['fa', 'fa-trash'],
                              class: "text-danger"
                            })
                          ], 8, _hoisted_163),
                          _createTextVNode("  "),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            title: _ctx.language.save_this_img,
                            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.saveImage(0)))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] })
                          ], 8, _hoisted_164)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_165, [
                _createElementVNode("h4", _hoisted_166, _toDisplayString(_ctx.language.e_comm_images), 1),
                _createElementVNode("div", _hoisted_167, [
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("div", _hoisted_170, [
                        _createElementVNode("div", _hoisted_171, [
                          _createElementVNode("h3", null, _toDisplayString(_ctx.language.add_image.toLowerCase()), 1),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.uploadImage(1)))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-plus'] })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["prod-image-zone", {'d-none':!_ctx.isEComm1Ready}])
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.prodImg1Src,
                          onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.previewProdImage(1)))
                        }, null, 8, _hoisted_172)
                      ], 2),
                      (_ctx.foundProduct.ProdImage1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.remove_this_img,
                              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.removeImage(1)))
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fa', 'fa-trash'],
                                class: "text-danger"
                              })
                            ], 8, _hoisted_174)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.allImages.image1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.remove_this_img,
                              onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.resetImage(1)))
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fa', 'fa-trash'],
                                class: "text-danger"
                              })
                            ], 8, _hoisted_176),
                            _createTextVNode("  "),
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.save_this_img,
                              onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.saveImage(1)))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] })
                            ], 8, _hoisted_177)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_178, [
                    _createElementVNode("div", _hoisted_179, [
                      _createElementVNode("div", _hoisted_180, [
                        _createElementVNode("div", _hoisted_181, [
                          _createElementVNode("h3", null, _toDisplayString(_ctx.language.add_image.toLowerCase()), 1),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.uploadImage(2)))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-plus'] })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["prod-image-zone", {'d-none':!_ctx.isEComm2Ready}])
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.prodImg2Src,
                          onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.previewProdImage(2)))
                        }, null, 8, _hoisted_182)
                      ], 2),
                      (_ctx.foundProduct.ProdImage2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.remove_this_img,
                              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.removeImage(2)))
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fa', 'fa-trash'],
                                class: "text-danger"
                              })
                            ], 8, _hoisted_184)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.allImages.image2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.remove_this_img,
                              onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.resetImage(2)))
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fa', 'fa-trash'],
                                class: "text-danger"
                              })
                            ], 8, _hoisted_186),
                            _createTextVNode("  "),
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.save_this_img,
                              onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.saveImage(2)))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] })
                            ], 8, _hoisted_187)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_188, [
                    _createElementVNode("div", _hoisted_189, [
                      _createElementVNode("div", _hoisted_190, [
                        _createElementVNode("div", _hoisted_191, [
                          _createElementVNode("h3", null, _toDisplayString(_ctx.language.add_image.toLowerCase()), 1),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.uploadImage(3)))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-plus'] })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["prod-image-zone", {'d-none':!_ctx.isEComm3Ready}])
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.prodImg3Src,
                          onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.previewProdImage(3)))
                        }, null, 8, _hoisted_192)
                      ], 2),
                      (_ctx.foundProduct.ProdImage3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.remove_this_img,
                              onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.removeImage(3)))
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fa', 'fa-trash'],
                                class: "text-danger"
                              })
                            ], 8, _hoisted_194)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.allImages.image3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.remove_this_img,
                              onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.resetImage(3)))
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fa', 'fa-trash'],
                                class: "text-danger"
                              })
                            ], 8, _hoisted_196),
                            _createTextVNode("  "),
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.save_this_img,
                              onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.saveImage(3)))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] })
                            ], 8, _hoisted_197)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_198, [
                    _createElementVNode("div", _hoisted_199, [
                      _createElementVNode("div", _hoisted_200, [
                        _createElementVNode("div", _hoisted_201, [
                          _createElementVNode("h3", null, _toDisplayString(_ctx.language.add_image.toLowerCase()), 1),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.uploadImage(4)))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-plus'] })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["prod-image-zone", {'d-none':!_ctx.isEComm4Ready}])
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.prodImg4Src,
                          onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.previewProdImage(4)))
                        }, null, 8, _hoisted_202)
                      ], 2),
                      (_ctx.foundProduct.ProdImage4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.remove_this_img,
                              onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.removeImage(4)))
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fa', 'fa-trash'],
                                class: "text-danger"
                              })
                            ], 8, _hoisted_204)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.allImages.image4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.remove_this_img,
                              onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.resetImage(4)))
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fa', 'fa-trash'],
                                class: "text-danger"
                              })
                            ], 8, _hoisted_206),
                            _createTextVNode("  "),
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.save_this_img,
                              onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.saveImage(4)))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] })
                            ], 8, _hoisted_207)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_208, [
                    _createElementVNode("div", _hoisted_209, [
                      _createElementVNode("div", _hoisted_210, [
                        _createElementVNode("div", _hoisted_211, [
                          _createElementVNode("h3", null, _toDisplayString(_ctx.language.add_image.toLowerCase()), 1),
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.uploadImage(5)))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-plus'] })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["prod-image-zone", {'d-none':!_ctx.isEComm5Ready}])
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.prodImg5Src,
                          onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.previewProdImage(5)))
                        }, null, 8, _hoisted_212)
                      ], 2),
                      (_ctx.foundProduct.ProdImage5)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.remove_this_img,
                              onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.removeImage(5)))
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fa', 'fa-trash'],
                                class: "text-danger"
                              })
                            ], 8, _hoisted_214)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.allImages.image5)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_215, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.remove_this_img,
                              onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.resetImage(5)))
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fa', 'fa-trash'],
                                class: "text-danger"
                              })
                            ], 8, _hoisted_216),
                            _createTextVNode("  "),
                            _createElementVNode("a", {
                              href: "javascript:;",
                              title: _ctx.language.save_this_img,
                              onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.saveImage(5)))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] })
                            ], 8, _hoisted_217)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_218, [
        _createElementVNode("div", _hoisted_219, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block",
            disabled: _ctx.v$.$invalid || _ctx.isSavingRecord || !_ctx.isDefaultTaxReqSet,
            onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.saveNewProduct && _ctx.saveNewProduct(...args)))
          }, [
            (_ctx.isSavingRecord)
              ? (_openBlock(), _createElementBlock("span", _hoisted_221, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-spinner'] }),
                  _createTextVNode("  ")
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
          ], 8, _hoisted_220)
        ])
      ])
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_ProdCategoryModal, {
        visible: _ctx.isCategoryVisible,
        initialValues: _ctx.newCategory,
        recordStatus: 0,
        onCloseForm: _ctx.onCloseCategory
      }, null, 8, ["visible", "initialValues", "onCloseForm"]),
      _createVNode(_component_ProdSubCategoryModal, {
        visible: _ctx.isSubCategoryVisible,
        listCategories: _ctx.lstCategories,
        initialValues: _ctx.newCategory,
        recordStatus: 0,
        onCloseForm: _ctx.onCloseSubCategory
      }, null, 8, ["visible", "listCategories", "initialValues", "onCloseForm"]),
      _createVNode(_component_ProdVariantModal, {
        visible: _ctx.isVariantCodeDlgVisible,
        initialValues: _ctx.variantCodeRecord,
        recordStatus: _ctx.variantCodeStatus,
        onCloseForm: _ctx.onCloseProdeCodeDlg
      }, null, 8, ["visible", "initialValues", "recordStatus", "onCloseForm"]),
      _createVNode(_component_ProdVariantValueModal, {
        visible: _ctx.isVariantDetailDlgVisible,
        initialValues: _ctx.variantDetailRecord,
        recordStatus: _ctx.variantDetailStatus,
        lstVariants: _ctx.lstProdVariants,
        basicProduct: _ctx.foundProduct,
        onCloseForm: _ctx.onCloseProdeDetailDlg
      }, null, 8, ["visible", "initialValues", "recordStatus", "lstVariants", "basicProduct", "onCloseForm"])
    ]))
  ], 64))
}